module.exports = __webpack_public_path__ + "static/DeceitWebCover_LARGE-29c7ae8af1f80d3985090f95ed4c75b8.jpeg";